import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { Grid, Divider,
} from "@material-ui/core";
import Input from "Components/Input/Input";
import { FACTOR_RESULT } from "Stores/actionTypes";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import Translator from "Languages/Utility/Translator";
import millimeterMask from "Components/Input/components/millimeterMask";

export default function SettingsUsageCharge() {
  const { factorResult } = useSelector((state) => ({
    factorResult: state.factor.factorResult,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [showInputs, setShowInputs] = useState(true);
  const [showLength, setShowLength] = useState(false);
  const [showLenBranch, setShowLenBranch] = useState(false);
  const [controls, setControls] = useSetState({
    ChargeValueGlass: {
      type: "percent",
      value: 0,
      row: 1,
      label: 'glass',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueNet: {
      type: "percent",
      value: 0,
      row: 1,
      label: 'net',
      validation: {
        isPercent: true,
      },
    },
    ModelOptimalFactor: {
      type: "radio",
      row: 2,
      value: { value: 0, key: "Profile_charge_manually" },
      items: [
        { value: 0, key: "Profile_charge_manually"},
        { value: 1, key: "Calculation_of_the_profile_value_based_on_the_number_of_branches_optimization"},
        { value: 2, key: "Calculation_of_waste_profile_and_adding_to_the_amount_of_profile"},
      ],
    },
    WeastOptimalFactor: {
      type: "millimeter",
      value: 0,
      row: 5,
      validation: {
        required: true,
        isNumeric: true,
      },
    },
    LenBranch: {
      type: "millimeter",
      value: 0,
      row: 5,
      validation: {
        required: true,
        isNumeric: true,
      },
    },
    ChargeValueFrameLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'frame',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueMulionLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'mulion',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueSashLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'sash',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueSashDoorLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'sash_door',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueDoorLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'sash_door',
      validation: {
        isPercent: true,
      },
    },
    ChargeValuePanelLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'panel',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueZehvarLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'zehvar',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueOtherLola: {
      type: "percent",
      value: 0,
      row: 3,
      label: 'others',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueFrameRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'frame',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueMulionRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'mulion',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueSashRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'sash',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueSashDoorRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'sash_door',
      validation: {
        isPercent: true,
      },
    },
    ChargeValuePanelRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'panel',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueZehvarRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'zehvar',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueOtherRail: {
      type: "percent",
      value: 0,
      row: 4,
      label: 'others',
      validation: {
        isPercent: true,
      },
    },
    ChargeValueDoorRail: {
      type: "percent",
      value: 0,
      row: -1,
      label: 'sash_door',
      validation: {
        isPercent: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    if(validation) {
      const result = {
        ...factorResult,
        [name]: +value,
      };
      dispatch({ type: FACTOR_RESULT, factorResult: result });
    }
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    const result = {
      ...factorResult,
      [name]: value.value,
    };
    dispatch({ type: FACTOR_RESULT, factorResult: result });
    changeShow(value.value);
  }

  useEffect(() => {
      if(factorResult.ChargeValueGlass) setControls({ChargeValueGlass: {value: factorResult.ChargeValueGlass}})
      if(factorResult.ChargeValueNet) setControls({ChargeValueNet: {value: factorResult.ChargeValueNet}})
      if(factorResult.ModelOptimalFactor) {
        setControls({ModelOptimalFactor: {value: controls.ModelOptimalFactor.items[factorResult.ModelOptimalFactor]}})
        changeShow(factorResult.ModelOptimalFactor);
      }
      if(factorResult.WeastOptimalFactor) setControls({WeastOptimalFactor: {value: factorResult.WeastOptimalFactor}})
      if(factorResult.LenBranch) setControls({LenBranch: {value: factorResult.LenBranch}})
      if(factorResult.ChargeValueFrameLola) setControls({ChargeValueFrameLola: {value: factorResult.ChargeValueFrameLola}})
      if(factorResult.ChargeValueSashLola) setControls({ChargeValueSashLola: {value: factorResult.ChargeValueSashLola}})
      if(factorResult.ChargeValueMulionLola) setControls({ChargeValueMulionLola: {value: factorResult.ChargeValueMulionLola}})
      if(factorResult.ChargeValueDoorLola) setControls({ChargeValueDoorLola: {value: factorResult.ChargeValueDoorLola}})
      if(factorResult.ChargeValuePanelLola) setControls({ChargeValuePanelLola: {value: factorResult.ChargeValuePanelLola}})
      if(factorResult.ChargeValueSashDoorLola) setControls({ChargeValueSashDoorLola: {value: factorResult.ChargeValueSashDoorLola}})
      if(factorResult.ChargeValueZehvarLola) setControls({ChargeValueZehvarLola: {value: factorResult.ChargeValueZehvarLola}})
      if(factorResult.ChargeValueOtherLola) setControls({ChargeValueOtherLola: {value: factorResult.ChargeValueOtherLola}})
      if(factorResult.ChargeValueFrameRail) setControls({ChargeValueFrameRail: {value: factorResult.ChargeValueFrameRail}})
      if(factorResult.ChargeValueSashRail) setControls({ChargeValueSashRail: {value: factorResult.ChargeValueSashRail}})
      if(factorResult.ChargeValueMulionRail) setControls({ChargeValueMulionRail: {value: factorResult.ChargeValueMulionRail}})
      if(factorResult.ChargeValueDoorRail) setControls({ChargeValueDoorRail: {value: factorResult.ChargeValueDoorRail}})
      if(factorResult.ChargeValuePanelRail) setControls({ChargeValuePanelRail: {value: factorResult.ChargeValuePanelRail}})
      if(factorResult.ChargeValueSashDoorRail) setControls({ChargeValueSashDoorRail: {value: factorResult.ChargeValueSashDoorRail}})
      if(factorResult.ChargeValueZehvarRail) setControls({ChargeValueZehvarRail: {value: factorResult.ChargeValueZehvarRail}})
      if(factorResult.ChargeValueOtherRail) setControls({ChargeValueOtherRail: {value: factorResult.ChargeValueOtherRail}})
  },[])

  const changeShow = (value) => {
    if (value === 0) {
      setShowInputs(true);
      setShowLength(false);
      setShowLenBranch(false);
    } else if (value === 2) {
      setShowLength(true);
      setShowInputs(false);
      setShowLenBranch(true);
    } else {
      setShowLength(false);
      setShowInputs(false);
      setShowLenBranch(true);
    }
  }

  return (
    <Grid container spacing={2} className="px-3 pb-3 mt-3">
      {
        Object.keys(controls).filter(key => controls[key].row === 1).map((key, index) => {
          return (
            <Grid item lg={3} md={6} xs={12} className="mb-2" key={key + index}>
              <Input
                setValue={setValue.bind(this)}
                value={controls[key].value}
                name={key}
                validation={controls[key].validation}
                label={<Translator id={controls[key].label}/>}
                endIcon="%"
              />
            </Grid>
          )
        })
      }
      <Grid item xs={12} className="mb-2">
        <MuiRadioGroup
          name="ModelOptimalFactor"
          value={controls.ModelOptimalFactor.value}
          items={controls.ModelOptimalFactor.items}
          onChange={onChangeRadio}
          translate={true}
          className="horizontalRadio"
        />
      </Grid>
      {
        showInputs && 
        <>
          <Grid item xs={12} md={6} className="p-3">
            <Grid container spacing={2} className="box-re-border p-2">
              <Translator id={"casementSystem"}/>
              <Divider className="mt-2"/>
              {
                Object.keys(controls).filter(key => controls[key].row === 3).map((key, index) => {
                  return (
                    <Grid item xs={6} key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={controls[key].label}/>}
                        endIcon="%"
                      />
                    </Grid>
                  )
                })
              }
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} className="p-3">
            <Grid container spacing={2} className="box-re-border p-2">
              <Translator id={"slidingSystem"}/>
              <Divider className="mt-2"/>
              {
                Object.keys(controls).filter(key => controls[key].row === 4).map((key, index) => {
                  return (
                    <Grid item xs={6} key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={controls[key].label}/>}
                        endIcon="%"
                      />
                    </Grid>
                  )
                })
              }
            </Grid>
          </Grid>
        </>
      }
      {
        showLength &&
        <Grid item lg={3} md={4} sm={6} xs={12} className="mt-3">
          <Input
            setValue={setValue.bind(this)}
            name="WeastOptimalFactor"
            value={controls.WeastOptimalFactor.value}
            validation={controls.WeastOptimalFactor.validation}
            label={<Translator id={"lengthLessThan"}/>}
            type="text"
            endIcon={<Translator id='millimeter' />}
            inputComponent={millimeterMask}
          />
        </Grid>
      }
      {
        showLenBranch &&
        <Grid item lg={3} md={4} sm={6} xs={12} className="mt-3">
          <Input
            setValue={setValue.bind(this)}
            name="LenBranch"
            value={controls.LenBranch.value}
            validation={controls.LenBranch.validation}
            label={<Translator id={"barLength"}/>}
            type="text"
            endIcon={<Translator id='millimeter' />}
            inputComponent={millimeterMask}
          />
        </Grid>
      }
    </Grid>
  );
}